import { bunja } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { atom } from 'jotai';
import { createContext } from 'react';

import { WhalePosition, whalePositionsBunja } from '@flipster/socket/r230522/whale-position';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import Num from '@flipster/utils/num';

const maxDisplayDurationSec = 30;
const minDisplayDurationSec = 5;
export const SymbolContext = createContext<string>('');
export const SymbolScope = createScopeFromContext(SymbolContext);

export const whalePositionBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const symbol = bunja.use(SymbolScope);
  const { whalePositionsAtom: socketWhalePositionsAtom } = bunja.use(whalePositionsBunja);
  const displayedTimeAtom = atom<number>(0);
  const currentWhalePositionAtom = atom<WhalePosition | null>(null);

  const resetWhalePositions = () => {
    store.set(displayedTimeAtom, 0);
    store.set(currentWhalePositionAtom, null);
  };

  const startDisplayTimer = () => {
    const updateDisplayedTime = () => {
      const displayedTime = store.get(displayedTimeAtom);
      store.set(displayedTimeAtom, displayedTime + 1);
      if (displayedTime >= maxDisplayDurationSec) {
        resetWhalePositions();
      }
    };

    updateDisplayedTime();
    const intervalId = setInterval(updateDisplayedTime, 1000);

    return () => clearInterval(intervalId);
  };

  bunja.effect(() => {
    const unsubSocketWhalePositions = store.sub(socketWhalePositionsAtom, () => {
      const newWhalePosition = store.get(socketWhalePositionsAtom)[0];
      const currentWhalePosition = store.get(currentWhalePositionAtom);
      const displayedTime = store.get(displayedTimeAtom);
      if (newWhalePosition.symbol !== symbol) return;
      if (currentWhalePosition) {
        if (displayedTime < minDisplayDurationSec) return;
        if (Num(newWhalePosition.positionSize).lte(Num(currentWhalePosition.positionSize))) return;
      }
      store.set(currentWhalePositionAtom, newWhalePosition);
      store.set(displayedTimeAtom, 0);
    });
    const clearDisplayTimer = startDisplayTimer();
    return () => {
      clearDisplayTimer();
      unsubSocketWhalePositions();
    };
  });

  return {
    currentWhalePositionAtom,
    resetWhalePositions,
  };
});
